<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                        :placeholder="$t('keyword')"></b-form-input>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-sorting" v-if="['owner','admin', 'account', 'operationsManager'].includes($store.state.user.role)">
        <div class="row">
          <div class="col-lg-12 c-sorting__right">
            <div class="c-sorting__btn">
              <button @click="create" class="btn btn-sm btn-success">
                <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-4">{{ $t('name') }}</div>
          <div class="col-lg-3">{{ $t('phone') }}</div>
          <div class="col-lg-3">{{ $t('email') }}</div>
          <div class="col-lg-3"></div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-4">
            <div>
              <b class="c-smart-table__label">{{ $t('name') }}: </b>
              <span>{{ item.name }}</span>&nbsp;
              <span v-if="item.title" class="badge badge-info text-wrap">{{ item.title }}</span>
            </div>
          </div>
          <div class="col-lg-3">
            <b class="c-smart-table__label">{{ $t('phone') }}: </b>
            <span v-if="item.phone">{{ item.phone }}</span>
            <i v-else class="text-secondary small">{{ $t('notUpdated') }}</i>
          </div>
          <div class="col-lg-3">
            <div>
              <b class="c-smart-table__label">{{ $t('email') }}: </b>
              <span v-if="item.email">{{ item.email }}</span>
              <i v-else class="text-secondary small">{{ $t('notUpdated') }}</i>
            </div>
          </div>
          <div class="col-lg-2 text-right">
            <div class="c-smart-table__content">
              <div class="c-buttons clearfix is-2">
                <div class="c-buttons__col">
                  <button @click="update(item._id)" type="button"
                          v-if="['owner','admin', 'account', 'operationsManager'].includes($store.state.user.role)"
                          class="btn btn-sm btn-info mr-1">
                    <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                  </button>
                  <button @click="del(item._id)" type="button"
                          v-if="['owner', 'account','admin'].includes($store.state.user.role)"
                          class="btn btn-sm btn-danger mr-1">
                    <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>

    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
      <form-input :label="$t('phone')" :model="formModel" attribute="phone" :errors="formErrors"></form-input>
      <form-input :label="$t('email')" :model="formModel" attribute="email" :errors="formErrors"></form-input>
      <form-input :label="$t('title')" :model="formModel" attribute="title" :errors="formErrors"></form-input>
    </b-modal>
  </div>
</template>

<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";

export default {
  props: ['client'],
  mixins: [List, CRUD],
  data: function () {
    return {
      autoLoad: true,
      service: '/client-contact',
      defaultFormModel: {
        client: this.client ? this.client._id : null
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: "Title"
      },
      vi: {
        title: "Chức danh"
      }
    }
  }
};
</script>